// extracted by mini-css-extract-plugin
export default {"zoomModal":"W2-z"};